import _ from "lodash";
import React from "react";
import classNames from "classnames";
import { useGraphSubscriptions } from "../hooks/GraphSubscriptionListContext";
import { StandardTableSortableHeader } from "../../../components/tables/StandardTable";

export const GraphSubscriptionTableHeader = ({ children, property, className } : Readonly<{ children: JSX.Element | string, className?: any | undefined, property: string }>) => {
    const { sort, sortTable } = useGraphSubscriptions()!;
    const sortProperties = sort.split(',');
    const isHeaderSorted = _.some(sortProperties, (i: string) => i.includes(property));
    const headerDirection = isHeaderSorted && _.some(sortProperties, (i: string) => i.toLowerCase().includes('+desc')) ? "desc" : null;

    const handleClick = () => sortTable(property);

    return (
        <StandardTableSortableHeader
            className={classNames(className)}
            active={isHeaderSorted}
            direction={headerDirection}
            onClick={handleClick}
            isSticky={true}
        >
            {children}
        </StandardTableSortableHeader>
    );
};

export default GraphSubscriptionTableHeader;